module.exports = __webpack_public_path__ + "img/MS.7b8cf289.png";